import { CourseForOverview, Numerical, PageStatus } from "../../../../types";
import Table from "rc-table";
import { ColumnsType } from "rc-table/es/interface";
import styles from "./index.module.scss";
import { useEffect, useRef, useState } from "react";
import CoachPage from "../../../../component/coach-page";
import Progress from "../progress";

type Category = CourseForOverview["categories"][0];
type Coach = Category["coaches"][0];
export interface GroupProps {
  category: Category;
  onUpdate: () => void;
}

const getStatusIcon = (status: PageStatus) => {
  if (status === "undo") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#575BFD" />
        <path
          d="M16.5 11.134C17.1667 11.5189 17.1667 12.4811 16.5 12.866L10.5 16.3301C9.83333 16.715 9 16.2339 9 15.4641L9 8.5359C9 7.7661 9.83333 7.28497 10.5 7.66987L16.5 11.134Z"
          fill="white"
        />
      </svg>
    );
  }
  if (status === "lock") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#DEDEDE" />
        <g clipPath="url(#clip0_8814_3524)">
          <path
            d="M10.5139 10.5195H9.00338V8.75724C9.00338 8.37363 9.07931 8.01598 9.23116 7.68432C9.383 7.35265 9.59279 7.06094 9.86053 6.80919C10.1283 6.55744 10.4439 6.35964 10.8076 6.21578C11.1712 6.07193 11.5688 6 12.0004 6C12.384 6 12.7536 6.07193 13.1093 6.21578C13.4649 6.35964 13.7806 6.55744 14.0563 6.80919C14.3321 7.06094 14.5518 7.35265 14.7157 7.68432C14.8795 8.01598 14.9614 8.37363 14.9614 8.75724V10.5195H13.5109V9.09291C13.5109 8.58941 13.371 8.1998 13.0913 7.92408C12.8116 7.64835 12.432 7.51049 11.9524 7.51049C11.5209 7.51049 11.1732 7.64835 10.9095 7.92408C10.6457 8.1998 10.5139 8.58941 10.5139 9.09291V10.5195ZM15.6807 11.2388C15.8965 11.2388 16.0823 11.3167 16.2381 11.4725C16.394 11.6284 16.4719 11.8142 16.4719 12.03V15.7463C16.4719 15.962 16.434 16.1638 16.358 16.3516C16.2821 16.5395 16.1782 16.7033 16.0463 16.8432C15.9145 16.983 15.7586 17.0929 15.5788 17.1728C15.399 17.2527 15.2012 17.2927 14.9854 17.2927H8.93146C8.71567 17.2927 8.51987 17.2527 8.34404 17.1728C8.16822 17.0929 8.01837 16.987 7.89449 16.8551C7.77062 16.7233 7.67471 16.5694 7.60678 16.3936C7.53885 16.2178 7.50488 16.03 7.50488 15.8302V12.03C7.50488 11.8142 7.58081 11.6284 7.73265 11.4725C7.8845 11.3167 8.06832 11.2388 8.2841 11.2388H9.00338H10.5139H13.5109H14.9614H15.6807Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_8814_3524">
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(6 6)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (status === "done") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#40BF9C" />
        <path
          d="M7.625 12.625L10.125 15.125L16.375 8.875"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return <div>{status}</div>;
};

const Group = ({ category, onUpdate }: GroupProps) => {
  console.log(category);
  const [curCoachId, setCurCoachId] = useState<Numerical>();
  const updateFunc = useRef(onUpdate);
  useEffect(() => {
    updateFunc.current = onUpdate;
  }, [onUpdate]);
  const handleClose = () => {
    setCurCoachId(0);
    updateFunc.current?.();
  };

  const handleClick = (record: Coach) => {
    if (record.status === "lock") {
      alert("课程为解锁");
    } else {
      setCurCoachId(record.id);
    }
  };
  const columns: ColumnsType<Coach> = [
    {
      title: category.title,
      dataIndex: "title",
      render: (_, record) => {
        return (
          <div
            style={{ display: "flex", alignItems: "center" }}
            onClick={() => handleClick(record)}
          >
            {getStatusIcon(record.status)}
            <span style={{ marginLeft: 12 }}>
              {record.number}. {record.title}
            </span>
          </div>
        );
      },
    },
    {
      title: (
        <Progress
          total={category.coaches?.length || 0}
          current={category.coaches?.filter((c) => c.status === "done")?.length}
          label="进度"
        />
      ),
      align: "right",
      width: 160,
      render: (_, record) => {
        if (record.challenge?.difficulty === "Easy") {
          return <div style={{ color: "#40BF9C" }}>简单</div>;
        }
        if (record.challenge?.difficulty === "Medium") {
          return <div style={{ color: "#FFC107" }}>中等</div>;
        }
        if (record.challenge?.difficulty === "Hard") {
          return <div style={{ color: "#FF5252" }}>困难</div>;
        }
        return "-";
      },
    },
  ];
  return (
    <div className={styles.group}>
      <Table columns={columns} rowKey="id" data={category.coaches} />
      {!!curCoachId && (
        <CoachPage challengeId={curCoachId} visible onClose={handleClose} />
      )}
    </div>
  );
};

export default Group;
